import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const Login = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append('username', username);
      formData.append('password', password);

      const response = await axios.post(`${BACKEND_URL}/api/auth/login`, formData, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });

      localStorage.setItem('token', response.data.access_token);
      toast.success('Login successful!');
      onLoginSuccess();
    } catch (error) {
      console.error('Auth error:', error);
      toast.error(error.response?.data?.detail || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <img 
            src="/simplex-logo.jpeg" 
            alt="Simplex Logo" 
            className="h-20 w-auto object-contain"
          />
        </div>

        <Card className="rounded-sm border-border shadow-lg">
          <CardHeader className="border-b border-border text-center">
            <CardTitle className="text-2xl font-bold uppercase tracking-tight">
              Production Dashboard
            </CardTitle>
            <p className="text-sm text-muted-foreground uppercase tracking-widest mt-2">
              Sign In
            </p>
          </CardHeader>
          <CardContent className="pt-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label htmlFor="username" className="text-sm uppercase tracking-wide">
                  Username
                </Label>
                <Input
                  id="username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  className="mt-1 rounded-sm"
                  placeholder="Enter your username"
                  data-testid="username-input"
                />
              </div>

              <div>
                <Label htmlFor="password" className="text-sm uppercase tracking-wide">
                  Password
                </Label>
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="mt-1 rounded-sm"
                  placeholder="Enter your password"
                  data-testid="password-input"
                />
              </div>

              <Button
                type="submit"
                className="w-full rounded-sm uppercase tracking-wide font-semibold"
                disabled={loading}
                data-testid="submit-button"
              >
                {loading ? 'Please wait...' : 'Sign In'}
              </Button>
            </form>
          </CardContent>
        </Card>

        <p className="text-center text-xs text-muted-foreground mt-4 uppercase tracking-widest">
          Secure Access • Real-Time Analytics
        </p>
      </div>
    </div>
  );
};
